import initialState from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  // const themes = getComputedStyle(document.element)
  switch (type) {
    case actionTypes.GET_SETTINGS_SUCCESS:
      return { ...state,
        limits: { min: payload.min_bet, max: payload.max_bet, win: payload.max_win },
        rtp: payload.rtp_coefficient,
        coefficients: Object.keys(state.coefficients).length !== 0 ?
        Object.entries(state.coefficients).reduce((newCoeffGroups, t) =>
          ({ ...newCoeffGroups, [t[0]] : Object.entries(t[1]).reduce((newCoeffs, tempCoef) =>
            ({ ...newCoeffs, [tempCoef[0]] : tempCoef[1]?.map(tempOldCoef => +(tempOldCoef * payload.rtp_coefficient).toFixed(2)) }), {}) }), {})
        : state.coefficients,
        colorTheme: payload.properties.color_theme && payload.themeNames.includes(payload.properties.color_theme) ? payload.properties.color_theme : 'orange',
        isHideMenu: payload.properties.is_hide_menu ? Boolean(payload.properties.is_hide_menu): false,
      }
      
    case actionTypes.START_GAME:
      return {
        ...state,
        gameStatus: 1,
        activeBalls: [...state.activeBalls, {
          road: payload.road,
          gameID: payload.gameID,
          roundID: payload.roundID,
          winning: payload.winning, 
          newBalance: payload.newBalance, 
          amount: payload.amount 
        }]
      }  

    case actionTypes.END_GAME:
      const newActiveBalls = state.activeBalls.filter(t => t.gameID !== payload.gameID)
      return {
        ...state,
        gameStatus: newActiveBalls.length > 0 ? 1 : 0,
        activeBalls: newActiveBalls,
        ballsHistory: [...state.ballsHistory, payload]
      }  

    case actionTypes.SET_START_INFO: {
      return { ...state,
        coefficients: state.rtp !== null ?
        Object.entries(payload.coefficients).reduce((newCoeffGroups, t) =>
          ({ ...newCoeffGroups, [t[0]] : Object.entries(t[1]).reduce((newCoeffs, tempCoef) =>
            ({ ...newCoeffs, [tempCoef[0]] : tempCoef[1]?.map(tempOldCoef => +(tempOldCoef * state.rtp).toFixed(2)) }), {}) }), {})
        : payload.coefficients,
      }
    }

    case actionTypes.SET_IS_PROCESS:
      return { ...state, isProcess: payload }
    
    case actionTypes.SET_GAME_SETTINGS: {
      return {
        ...state,
        gameSettings: { ...state.gameSettings, ...payload },
        temp_pick: (state.gameStatus === 0 || state.gameStatus === 2) ? initialState.temp_pick : state.temp_pick,
      }
    }

    case actionTypes.PICK:
      return { ...state,
        temp_pick: payload,
      }

    case actionTypes.COMPLETE_GAME:
      return { ...state,
      temp_pick: payload,
      gameStatus: 0,
    }  

    case actionTypes.LOST:
      return {
        ...state,
        gameStatus: 2,
        temp_pick: payload,
      }

    default: return state;
  }
}